<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title">
        <i class="nc-icon nc-badge" aria-hidden="true"></i>
        {{ title }}
        <!-- <i class="fa fa-child" aria-hidden="true"></i> -->
      </h4>
    </div>
    <div class="card-body">
      <ul class="list-unstyled team-members">
        <li>
          <div class="row" v-for="member in members">
            <div class="col-2 col-md-2">
              <div class="avatar">
                <i
                  class="fa fa-user-circle-o fa-2x"
                  :class="getStatusClass(member.estadoCuenta.glosa)"
                  aria-hidden="true"
                ></i>
              </div>
            </div>
            <div class="col-md-7 col-7">
              {{ member.nombreUsuario }}
              <br />
              <span :class="getStatusClass(member.estadoCuenta.glosa)">
                <small>{{ member.estadoCuenta.glosa }}</small>
              </span>
            </div>

            <div class="col-md-3 col-3 text-right">
              <p-button size="sm" type="success" outline icon round>
                <i class="fa fa-pencil"></i>
              </p-button>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { Button, Modal } from "src/components/UIComponents";
export default {
  components: {
    [Button.name]: Button,
    Modal,
  },
  data() {
    return {
      title: "Tu Equipo",
      members: [
        {
          nombreUsuario: "Usuario 1",
          usuarioSesion: "USER1",
          perfilCuenta: { _id: "", glosa: "GESTION" },
          estadoCuenta: { _id: "", glosa: "ACTIVA" },
          fehcaUltimoAcceso: "2024-04-25T23:01:34.426Z",
        },
        {
          nombreUsuario: "Usuario 2",
          usuarioSesion: "USER2",
          perfilCuenta: { _id: "", glosa: "GESTION" },
          estadoCuenta: { _id: "", glosa: "BLOQUEADA" },
          fehcaUltimoAcceso: "2024-04-25T23:01:34.426Z",
        },
        {
          nombreUsuario: "Usuario 3",
          usuarioSesion: "USER3",
          perfilCuenta: { _id: "", glosa: "ADMINISTRADOR" },
          estadoCuenta: { _id: "", glosa: "PENDIENTE" },
          fehcaUltimoAcceso: "2024-04-25T23:01:34.426Z",
        },
      ],
    };
  },
  methods: {
    getStatusClass(status) {
      switch (status) {
        case "PENDIENTE" || "ELIMINADA":
          return "text-muted";
        case "ACTIVA":
          return "text-success";
        case "BLOQUEADA" || "BLOQUEADA POR MORA":
          return "text-danger";
        default:
          return "text-success";
      }
    },
    async handlePasswordChange() {},
  },
};
</script>
<style></style>
